import { render, staticRenderFns } from "./CooperationNutraceuticals.vue?vue&type=template&id=69f51cee"
import script from "./CooperationNutraceuticals.vue?vue&type=script&lang=js"
export * from "./CooperationNutraceuticals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69f51cee')) {
      api.createRecord('69f51cee', component.options)
    } else {
      api.reload('69f51cee', component.options)
    }
    module.hot.accept("./CooperationNutraceuticals.vue?vue&type=template&id=69f51cee", function () {
      api.rerender('69f51cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/manager/pharmacy/Cooperation/CooperationNutraceuticals.vue"
export default component.exports